// Initialize and default

$(document).ready(function () {

  $(".radioListEnum").hide();
  $(".join-step2").hide();
  $(".join-step3").hide();
  $(".join-step3-individual").hide();

  $('.ui.form.join-step1')
    .form().submit(function (event) {
      event.preventDefault();

      // no validation needed for this one, therefore render step 2
      $(".join-step1").hide();
      $(".join-step2").show();

      return false;
    });

  $('.ui.form.join-step2')
    .form({
      fields: {
        FirstName: {
          identifier: 'FirstName',
          rules: [
            {
              type: 'empty',
              prompt: 'Please enter your first name',
            }
          ]
        },
        LastName: {
          identifier: 'LastName',
          rules: [
            {
              type: 'empty',
              prompt: 'Please enter your last name'
            }
          ]
        },
        Email: {
          identifier: 'Email',
          rules: [
            {
              type: 'email',
              prompt: 'Please enter your email address'
            }
          ]
        },
        Password: {
          identifier: 'Password',
          rules: [
            {
              type: 'empty',
              prompt: 'Please enter your password'
            },
            {
              type: 'minLength[8]',
              prompt: 'Password must have at least 8 characters.'
            },
            {
              type: 'regExp[/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,!@#\$%\^&\*])(?=.{1,})/]',
              prompt: 'Your password must contain at least one upper case letter, one lower case letter, one number and one special character.'
            }
          ]
        },
        ConfirmationPassword: {
          identifier: 'ConfirmationPassword',
          rules: [
            {
              type: 'match[Password]',
              prompt: 'Password confirmation mismatch'
            }
          ]
        },
      }
    }).submit(function (event) {
      event.preventDefault();

      var isPasswordMismatch = false;

      if ($(this).form('is valid') && !isPasswordMismatch) {

        console.log('validation successful');

        // Hide company input for individuals
        var clientType = $("input[name='ClientType']:checked").val();
        if (clientType === "Individual") {
          $("#company-name").hide();
        } else {
          $("#company-name").show();
        }

        // transfer value to step 3
        $(".Step3ClientType").val(clientType);
        $(".Step3FirstName").val($("input[name='FirstName']").val());
        $(".Step3LastName").val($("input[name='LastName']").val());
        $(".Step3Email").val($("input[name='Email']").val());
        $(".Step3Password").val($("input[name='Password']").val());
        $(".Step3ConfirmationPassword").val($("input[name='ConfirmationPassword']").val());

        // passed validation proceed to step 3
        if ($("input[name='ClientType']:checked").val() !== "Individual") {
          $(".join-step2").hide();
          $(".join-step3").show();
        }
        else {
          $(".join-step2").hide();
          $(".join-step3-individual").show();
        }
      }

      else if (!$(this).form('is valid') && $("input[name='FirstName']").val().length === 0 || $("input[name='LastName']").val().length === 0) {
        $("#label-name").css({ "color": "#9f3a38" });
      }

      else if ($("input[name='FirstName']").val().length !== 0 && $("input[name='LastName']").val().length !== 0) {
        $("#label-name").css({ "color": "rgba(0,0,0,.87)" });
      }

      return false;
    });

  $('.ui.form.join-step3')
    .form({
      CompanyName: {
        identifier: 'CompanyName',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your company name'
          }
        ]
      },
      FSPNumber: {
        identifier: 'FSPNumber',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your FSP number'
          }
        ]
      },
      AddressLine1: {
        identifier: 'AddressLine1',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your address'
          }
        ]
      },
      SubUrb: {
        identifier: 'SubUrb',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your suburb'
          }
        ]
      },
      City: {
        identifier: 'City',
        optional: true
      },
      Country: {
        identifier: 'Country',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your country'
          }
        ]
      },
      PostCode: {
        identifier: 'PostCode',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your post code'
          }
        ]
      },
      Phone: {
        identifier: 'Phone',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your phone'
          }
        ]
      },
      Mobile: {
        identifier: 'Mobile',
        rules: [
          {
            type: 'empty',
            prompt: 'Please enter your mobile number'
          }
        ]
      },
      TermsAgreed: {
        identifier: 'TermsAgreed',
        rules: [
          {
            type: 'checked',
            prompt: 'Please accept terms and conditions'
          }
        ]
      },
      IsFSP: {
        identifier: 'IsFSP',
        rules: [
          {
            type: 'checked',
            prompt: 'You must be a financial services professional to register'
          }
        ]
      },
    }).submit(function (event) {

      if (!$(this).form('is valid')) {
        event.preventDefault();


        if ($("input[name='SubUrb']").val().length === 0 || $("input[name='Country']").val().length === 0 || $("input[name='PostCode']").val().length === 0) {
          $("#label-locality").css({ "color": "#9f3a38" });
        }

        else if ($("input[name='SubUrb']").val().length !== 0 && $("input[name='Country']").val().length !== 0 && $("input[name='PostCode']").val().length !== 0) {
          $("#label-locality").css({ "color": "rgba(0,0,0,.87)" });
        }

        return false;
      }
      else {
        $('#joinsegment').addClass('loading');
      }
    });

  $('.ui.form.join-step3-individual')
    .form({
      fields: {
        Phone: {
          identifier: 'Phone',
          rules: [
            {
              type: 'empty',
              prompt: 'Please enter your phone'
            }
          ]
        },
        Mobile: {
          identifier: 'Mobile',
          rules: [
            {
              type: 'empty',
              prompt: 'Please enter your mobile number'
            }
          ]
        },
        TermsAgreed: {
          identifier: 'TermsAgreed',
          rules: [
            {
              type: 'checked',
              prompt: 'Please accept terms and conditions'
            }
          ]
        },
      }
    }).submit(function (event) {

      if (!$(this).form('is valid')) {
        event.preventDefault();

        return false;
      }
      else {
        $('#joinsegment').addClass('loading');
      }
    });
});

$(".radioListEnum").change(function (e) {

  var label0 = document.getElementById("lblClientType_0");
  label0.className = label0.className.replace(" selected", "");
  var label1 = document.getElementById("lblClientType_1");
  label1.className = label1.className.replace(" selected", "");
  //var label2 = document.getElementById("lblClientType_2");
  //label2.className = label2.className.replace(" selected", "");

  if (e.currentTarget.checked === true) {
    var label = document.getElementById("lbl" + e.currentTarget.id);
    label.className += " selected";
  }

  // Hide company input for individuals
  var clientType = $("input[name='ClientType']:checked").val();
  if (clientType === "Individual") {
    $("#company-name").hide();
  } else {
    $("#company-name").show();
  }
}
)

$('.btnPrevious')
  .click(function (event) {
    //// no validation needed for this one, therefore render previous step
    $(".join-step" + event.currentTarget.name).hide();

    if ($("input[name='ClientType']:checked").val() === "Individual" && event.currentTarget.name === "3-individual") {
      $(".join-step2").show();
    }
    else {
      $(".join-step" + (event.currentTarget.name - 1)).show();
    }
  });

$('.sign-in-button').click(function () {
  $('#congratulations-segment').addClass('loading');
});
